import { Box, Stack, Typography, useTheme } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { GREEN_COLOR, ORANGE_COLOR } from '../../../constants';
import { NumberLetterObj } from './PinCodeGame';

interface LetterRowProps {
  values: string[];
  isHighlighted: boolean;
  pincode: string[];
  currentRowIndex: number;
  rowIndex: number;
  updateKeyboardCharIndicator: (value: string, type: number) => void;
  numberLetters: NumberLetterObj[];
}

const LetterRow: FC<LetterRowProps> = ({
  values,
  isHighlighted,
  pincode,
  currentRowIndex,
  rowIndex,
  updateKeyboardCharIndicator,
  numberLetters,
}) => {
  const doColor = currentRowIndex > rowIndex;

  return (
    <Stack
      direction="row"
      display="flex"
      justifyContent="space-between"
      sx={(theme) => ({ width: '100%' })}
    >
      {values.map((value, index) => (
        <LetterItem
          key={index}
          index={index}
          value={value}
          isHighlighted={isHighlighted}
          pincode={pincode}
          doColor={doColor}
          updateKeyboardCharIndicator={updateKeyboardCharIndicator}
          numberLetters={numberLetters}
        />
      ))}
    </Stack>
  );
};

type LetterItemProps = {
  index: number;
  value: string;
  isHighlighted: boolean;
  pincode: string[];
  doColor: boolean;
  updateKeyboardCharIndicator: (value: string, type: number) => void;
  numberLetters: NumberLetterObj[];
};

const LetterItem: FC<LetterItemProps> = ({
  index,
  value,
  isHighlighted,
  pincode,
  doColor,
  updateKeyboardCharIndicator,
  numberLetters,
}) => {
  const theme = useTheme();
  const [faded, setFaded] = useState(false);
  const delay = 2;
  const [colorChecked, setColorChecked] = useState(false);
  const [color, setColor] = useState<string>(
    theme.palette.card?.main || '#fff'
  );

  // let color = theme.palette.card?.main;

  const checkValue = (
    letterValue: string,
    letterIndex: number,
    pincode: string[]
  ): string => {
    if (!colorChecked) {
      const obj = numberLetters.find(
        (val: NumberLetterObj) => val.letter === letterValue
      );

      const num = obj?.number || '-';

      let index = 0;
      let type = 0;

      // if (obj?.correctPosition !== 2) {
      if (pincode.includes(num)) {
        setColor(ORANGE_COLOR);
        // color = ORANGE_COLOR;
        index = pincode.indexOf(num);
        type = 1;
        if (letterIndex === index) {
          setColor(GREEN_COLOR);
          // color = GREEN_COLOR;
          type = 2;
        }
      } else {
        type = 3; // doesnt exist in pincode
      }

      updateKeyboardCharIndicator(num, type);
      // }
      setColorChecked(true);
    }
    return color;
  };

  useEffect(() => {
    let timer = null;
    if (doColor) {
      timer = setTimeout(() => {
        setFaded(true);
      }, delay);
    }

    return () => {
      if (timer !== null) {
        clearTimeout(timer);
      }
    };
  }, [delay, value, doColor]);

  return (
    <Box
      sx={(theme) => ({
        width: 63,
        height: 63,
        borderRadius: 1,
        backgroundColor: faded ? checkValue(value, index, pincode) : '',
        // boxShadow: `${theme.palette.boxBorder?.main} 2px 2px 3px 1px`,
        opacity: faded ? 1 : 0,
        transition:
          'background-color 1s ease-in-out, box-shadow 0.5s ease-in, border-bottom 0.5s ease-in, border-right 0.5s ease-in, opacity 0.5s ease-in', // Smooth fade effect
      })}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h4">{value.toUpperCase()}</Typography>
    </Box>
  );
};

export default LetterRow;
